import styled from '@emotion/styled'
import { Button, Spin } from 'antd'

export const ScreenLoading = styled('div')`
  position: absolute;
  background: rgba(0, 0, 0, 0.24);
  width: 100%;
  height: 100%;
`

export const SpinLoading = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const ProgressText = styled('div')`
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  z-index: 1;
`

export const ButtonRetry = styled(Button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffa100;
  color: #ffffff;
  
  border-color: #ffa100;
`
